import Navbar from "./components/Navbar";
import FloatingNavbar from "./components/FloatingNavbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Stats from "./pages/Stats";
import About from "./pages/About";
import Skills from "./pages/Skills";
import Experience from "./pages/Experience";
import Education from "./pages/Education";
import Projects from "./pages/Projects";
import Certifications from "./pages/Certifications";
import Awards from "./pages/Awards";
import Contact from "./pages/Contact";
import Instructor from "./pages/Instructor";

import Chatbot from "./components/Chatbot";

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0f0f0f] to-[#1f1f1f] text-white font-sans scroll-smooth relative">

      {/* Apple Dynamic Island Navbar */}
      <FloatingNavbar />

      {/* Normal Navbar */}
      {/* <Navbar /> */}

      <div className="pt-24 space-y-6 md:space-y-10 px-4 max-w-7xl mx-auto">

        <section id="home" className="scroll-mt-32"><Home /></section>
        <section id="stats" className="scroll-mt-32"><Stats /></section>
        <section id="about" className="scroll-mt-32"><About /></section>
        <section id="skills" className="scroll-mt-32"><Skills /></section>
        <section id="experience" className="scroll-mt-32"><Experience /></section>
        <section id="education" className="scroll-mt-32"><Education /></section>
        <section id="projects" className="scroll-mt-32"><Projects /></section>
        <section id="instructor" className="scroll-mt-32"><Instructor /></section>
        <section id="certifications" className="scroll-mt-32"><Certifications /></section>
        <section id="awards" className="scroll-mt-32"><Awards /></section>
        <section id="contact" className="scroll-mt-32"><Contact /></section>

      </div>

      <Footer />
      <Chatbot />

    </div>
  );
}

export default App;